import type { ColorProperty, ColorPropertyInput } from '@src/types';
import { execAdmin } from '../utils';

const gql = String.raw;

interface ColorPropertyGraphQL {
  id: number;
  code: string;
  display: string;
  hexCode?: string | null;
  url?: string | null;
  synonyms: string[];
  family: string[];
  createdAt: string;
  updatedAt: string;
}

interface UpdateColorPropertyInput {
  code?: string;
  display?: string;
  hexCode?: string | null;
  url?: string | null;
  synonyms?: string[];
  family?: string[];
}

interface UpdateColorPropertyResponse {
  partner: {
    updateColorProperty: ColorPropertyGraphQL;
  };
}

interface UpdateColorPropertyVariables {
  partnerCode: string;
  id: number;
  input: UpdateColorPropertyInput;
}

const UPDATE_COLOR_PROPERTY_MUTATION = gql`
  mutation updateColorProperty($partnerCode: String!, $id: Int!, $input: ColorPropertyUpdateInputTypeAdmin!) {
    partner(code: $partnerCode) {
      updateColorProperty(id: $id, input: $input) {
        id
        code
        display
        hexCode
        url
        synonyms
        family
        createdAt
        updatedAt
      }
    }
  }
`;

export const updateColorProperty = async ({
  id,
  partnerCode,
  token,
  data,
}: {
  id: number;
  partnerCode: string;
  token: string;
  data: Partial<ColorPropertyInput>;
}): Promise<ColorProperty> => {
  const input: UpdateColorPropertyInput = {
    code: data.code,
    display: data.display,
    hexCode: data.hex_code || null,
    url: data.url || null,
    synonyms: data.synonyms,
    family: data.family,
  };

  const variables: UpdateColorPropertyVariables = {
    partnerCode,
    id,
    input,
  };

  const response = await execAdmin<UpdateColorPropertyVariables, UpdateColorPropertyResponse>(
    UPDATE_COLOR_PROPERTY_MUTATION,
    { variables }
  );

  const updated = response.partner.updateColorProperty;

  // Map GraphQL camelCase to frontend snake_case
  return {
    id: updated.id,
    partner_code: partnerCode,
    code: updated.code,
    display: updated.display,
    hex_code: updated.hexCode,
    url: updated.url,
    synonyms: updated.synonyms,
    family: updated.family,
    created_at: updated.createdAt,
    updated_at: updated.updatedAt,
  };
};
